import { useLoading } from "../contexts/LoadingContext";

export default function LoadingOverlay() {
  const { isVisible } = useLoading();

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 bg-white/70 flex flex-col items-center justify-center space-y-6">
      <div className="flex flex-col items-center space-y-2">
        <img src="/logo512.png" alt="Sous logo" className="w-16 h-16 opacity-80" />
        <h1 className="text-4xl font-light tracking-tight text-[#1F2937]">Sous.</h1>
      </div>
      <div className="w-12 h-12 rounded-full border-4 border-sage border-t-transparent animate-spin"></div>
    </div>
  );  
}
